import React, { FunctionComponent } from 'react'
import { SaleAddressModal } from '../address/SaleAddressModal'
import { useSaleAddressModal } from './useSaleAddressModal'

export const SaleAddressModalContainer: FunctionComponent = () => {
  const { state } = useSaleAddressModal()

  if (!state.isOpen) {
    return null
  }

  return (
    <SaleAddressModal
      formType={state.formType}
      fulfillmentDetails={state.fulfilmentDetails}
      onClose={state.onClose}
      onSave={state.onSave}
    />
  )
}
